import React, { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api, { getCsrfToken } from '../api/axios';

function Webinarredirect() {
  const { idtransaction } = useParams();
  const navigate = useNavigate();

  const snapCalledRef = useRef(false);
  const snapLoadedRef = useRef(false);

  useEffect(() => {
  if (snapCalledRef.current) return; // ⛔ cegah 2x
  snapCalledRef.current = true;

  const startPayment = async () => {
    try {
      const res = await api.get(
        `/api/webinar-payment-by-transaction/${idtransaction}`
      );

      const paymentPayload = {
        nama: res.data.name,
        hp: res.data.number,
        status: res.data.status,
        webinar_id: res.data.webinar_id,
        transaction_id: res.data.transaction_id,
        member_id: res.data.member_id,
      };

      const price = res.data.webinar?.price;
      if (!price) throw new Error('Harga webinar tidak ditemukan');

      await getCsrfToken();

      const response = await fetch(
        `https://akad.in/api/midtrans-api/${idtransaction}/${price}`
      );
      
      // ❌ jika HTTP error
      if (!response.ok) {
        navigate('/webinar');
        return;
      }

      const data = await response.json();

      // ❌ jika token kosong
      if (!data?.token) {
        navigate('/webinar');
        return;
      }

      // ✅ cek apakah snap.js sudah ada
      if (!document.getElementById('midtrans-snap')) {
        const scriptSnap = document.createElement('script');
        scriptSnap.id = 'midtrans-snap';
        scriptSnap.src = 'https://app.midtrans.com/snap/snap.js';
        scriptSnap.setAttribute(
          'data-client-key',
          'Mid-client--21_FPKQFN6BmJjf'
        );
        scriptSnap.async = true;
        document.body.appendChild(scriptSnap);

        scriptSnap.onload = () => openSnap(data, paymentPayload, price);
      } else {
        openSnap(data, paymentPayload, price);
      }

    } catch (err) {
      console.error('Payment error:', err);
    }
  };

  const openSnap = (data, paymentPayload, price) => {
    if (!window.snap || !data?.token) return;

    if (snapLoadedRef.current) return; // ⛔ cegah popup dobel
    snapLoadedRef.current = true;

    window.snap.pay(data.token, {
      onSuccess: async (result) => {
        try {
          await api.post('/api/webinar-payments', {
            name: paymentPayload.nama,
            number: paymentPayload.hp,
            status: paymentPayload.status,
            webinar_id: paymentPayload.webinar_id,
            transaction_id: idtransaction,
            member_id: paymentPayload.member_id,
            payment_type: result.payment_type
          });

          navigate(`/webinar/success/${idtransaction}/${price}`);
        } catch (e) {
          console.error(e);
        }
      },
      onPending: () => navigate('/webinar'),
      onError: () => navigate('/webinar'),
    });
  };

  startPayment();
}, [idtransaction, navigate]);


  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Mohon tunggu, memproses pembayaran...</h2>
    </div>
  );
}

export default Webinarredirect;
